import { z } from 'zod';

const trimmedStr = z.string().trim();
const trimmedReqStr = z.string().trim().min(1, { message: 'Required field' });

const selectOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const salesCenterFormSchema = z.object({
  name: trimmedReqStr,
  description: trimmedStr,

  equipment: z.object({
    type: selectOptionSchema.array(),
  }),

  customer: z.object({
    type: selectOptionSchema.array(),
    paymentType: selectOptionSchema.array(),
  }),

  address: z.object({
    zip: trimmedStr,
    city: trimmedStr,
    state: trimmedStr,
    county: trimmedStr,
    country: trimmedStr,
  }),

  charges: z.array(
    z.object({
      type: trimmedStr,
      amount: z.number(),
      name: trimmedReqStr,
      isTaxable: z.boolean(),
      description: trimmedStr,
      amountType: trimmedReqStr,
      isEquipmentLvl: z.boolean(),
    })
  ),

  taxes: z.array(
    z.object({
      type: trimmedStr,
      amount: z.number(),
      name: trimmedReqStr,
      isTaxable: z.boolean(),
      amountType: trimmedReqStr,
      description: trimmedStr,
      isEquipmentLvl: z.boolean(),
    })
  ),
});

export type DealSheetFormValues = z.infer<typeof salesCenterFormSchema>;
